import React, { useEffect, useState } from 'react';
import { InputGroup } from 'react-bootstrap';
import Button from '../UI/ActionButton';
import { FormControlInput, FormGroupInput, LabelInput, SelectInput } from './styles';
import ConsultaProduto from "../../../lib/json/consultas/Produtos.json"
import ConsultaTotvs from '../../../backend/ConsultaTotvs';
import LoadingSpinner from '../LoadinSpinner';
import IconComponent from '../Icons';
																		
const BuscaProduto = ({empresaFilial, handleProduto, campoProduto, queryComplemento = '', label = 'Produto:', bindItem, field, disabled=false}) => {
    const [buscaProdutoInput, setBuscaProdutoInput] = useState("");
    const [options, setOptions] = useState([]);
    const [showSelect, setShowSelect] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [menuopen, setMenuOpen] = useState(true);
  
    const loadOptions = async () => {
        if (buscaProdutoInput){
            setIsLoading(true);

            const search = buscaProdutoInput
            const terms = search.split(" "); // ['Tenis', 'Confort']

            let conditions = terms.map(term => `( B1_COD LIKE '%${term}%' OR B1_DESC LIKE '%${term}%' OR B5_CEME LIKE '%${term}%' ) `).join(" AND ");

            let cConsulta = ConsultaProduto.consulta + ( conditions ? 'AND ' + conditions : '' )

            //Implementar Regra de Filtragem de Grupos de Produtos Habilitados
            if (queryComplemento){
                cConsulta += queryComplemento
            }

            var retConsulta = await ConsultaTotvs( cConsulta, ConsultaProduto.tabelas, empresaFilial );

            if (retConsulta.data){
                if (retConsulta.data.length > 0){
                    const formattedOptions = retConsulta.data.map(option => ({
                        value: option.B1_COD,
                        label: `${option.B1_COD} - ${option.DESCRI}`,
                        origem: option
                    }));

                    setOptions(formattedOptions);                    
                }
            }

            setIsLoading(false);
        }
    };

    const handleSearch = () => {
        loadOptions();				
    };

    useEffect( () =>{
        if (!campoProduto){
            setMenuOpen(true)
            setShowSelect(false)
            setBuscaProdutoInput("")
        }else{
            setMenuOpen(false)
            setShowSelect(true)
        }
    },[campoProduto])

    useEffect( () => {
        if (options.length  > 0){
            setMenuOpen(true);
            setShowSelect(true);
            setBuscaProdutoInput("")
        }
    },[options])

    const handleRetorno = (e) => {
        handleProduto(e, bindItem)
    }

    return (
        <>
            <LoadingSpinner isLoading={isLoading}/>
            <FormGroupInput controlId="searchInput">
                <LabelInput id="inputGroup-sizing-sm" className="input-group-text">{label}</LabelInput>
                <InputGroup className="mb-3">
                    {showSelect ? (
                        <SelectInput
                            defaultInputValue={buscaProdutoInput}
                            defaultMenuIsOpen={menuopen}
                            isClearable
                            isSearchable
                            autoFocus
                            options={options}
                            isLoading={isLoading}
                            placeholder="Selecione um produto..."
                            onChange={handleRetorno}
                            value={campoProduto}
                            isDisabled={disabled}
                        />
                    ) : (
                        <>
                            <FormControlInput
                                placeholder="Digite aqui..."
                                aria-label="Digite aqui..."
                                aria-describedby="basic-addon2"
                                value={buscaProdutoInput}
                                onChange={(e) => setBuscaProdutoInput(e.target.value.toUpperCase())}
                                disabled={disabled}
                            />
                            <Button variant="primary" onClick={handleSearch}><IconComponent icon={"AiOutlineSearch"}/> Buscar</Button>
                        </>
                    )}
                </InputGroup>
            </FormGroupInput>
        </>
    );
};

export default BuscaProduto;
